// アコーディオンパネル開閉
const faqList = document.querySelectorAll(".js-faqList");

faqList.forEach((faqList) => {
  faqList.addEventListener("click", () => {
    faqList.classList.toggle("is_open");
    const btn = faqList.querySelector(".js-faq__button");
    btn.classList.toggle("clicked");
  });
});

// totop
$(function(){
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 100) {
      $(".totop-pc").fadeIn();
    } else {
      $(".totop-pc").fadeOut();
    }
  });
  $('a[href^="#"]').click(function () {
    var speed = 500;
    var spheaderH = 78; //SP固定ヘッダーの高さ
    var pcheaderH = 78; //PC固定ヘッダーの高さ
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var spposition = target.offset().top - spheaderH;
    var pcposition = target.offset().top - pcheaderH;
    if (window.matchMedia("(max-width: 767px)").matches) {
      $("html, body").animate({ scrollTop: spposition }, speed, "swing");
      return false;
    } else {
      $("html, body").animate({ scrollTop: pcposition }, speed, "swing");
      return false;
    }
  });
});

$(function () {
  //ヘッダー
  $(".js-pcToggle, .h-nav__link").on("click", function () {
    $(".js-pcToggle").toggleClass("is-active");
    $("html").toggleClass("is-fixed");
    $("#js-pcNav").fadeToggle();
  });

  //モーダル
  $("#js-modal-toggle01").on("click", function () {
    $("#js-modal01").fadeIn();
    $("html").addClass("is-fixed");
    return false;
  });
  $("#js-modal-toggle02").on("click", function () {
    $("#js-modal02").fadeIn();
    $("html").addClass("is-fixed");
    return false;
  });

  $(".batsu, .js-close").on("click", function () {
    $("#js-modal01").fadeOut();
    $("#js-modal02").fadeOut();
    $("html").removeClass("is-fixed");
    return false;
  });
  $("#js-modal01").on("click", function (e) {
    $("#js-modal01").fadeOut();
    $("html").removeClass("is-fixed");
    return false;
  });
  $("#js-modal02").on("click", function (e) {
    $("#js-modal02").fadeOut();
    $("html").removeClass("is-fixed");
    return false;
  });
  $(".casestudy__box").on("click", function (e) {
    e.stopPropagation();
  });
});

